import React, { useEffect, useMemo, useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  Snackbar,
  Typography,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import BasicInfo from "../components/userAddtabs/basicInfo";
import Companyselection from "../components/userAddtabs/companyselection";
import BranchSelection from "../components/userAddtabs/branchSelection";
import axios from "axios";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import UserDetailsPreview from "./userDetailsPreview";
import PermissionUI from "../components/userAddtabs/permissionUI";
import ModalLoadingOverlay, {
  modalLoadingContainerSx,
} from "../components/ModalLoadingOverlay";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "90%", md: 800 },
  height: "95vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

// ── Same styling as AddCompany / AddBranch ─────────────────────────
const sectionLabel = (text) => (
  <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#000", mb: 1 }}>
    {text}
  </Typography>
);

const cancelBtnSx = {
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  fontWeight: 500,
  fontSize: "12px",
  borderRadius: "16px",
  minWidth: "132px",
  minHeight: "32px",
  px: 1.5,
  py: 1,
  backgroundColor: "#F8F9FB",
  color: "#6B7280",
  border: "1px solid #D0D5DD",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#F2F4F7",
    border: "1px solid #C3C9D4",
    boxShadow: "none",
  },
};

const primaryBtnSx = {
  backgroundColor: "#3F95EA",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 500,
  minWidth: "90px",
  minHeight: "32px",
  px: 1.5,
  py: 1,
  fontSize: "12px",
  "&:hover": { backgroundColor: "#2563EB" },
};

const StepTab = ({ label, index, activeStep, onTabClick, isClickable }) => {
  const isActive = index === activeStep;
  return (
    <Box
      onClick={() => isClickable && onTabClick(index)}
      sx={{
        display: "flex",
        alignItems: "center",
        pt: "10px",
        pb: "10px",
        borderBottom: isActive ? "2px solid #3F95EA" : "2px solid transparent",
        cursor: isClickable ? "pointer" : "default",
        px: 0.5,
        transition: "border-color 0.15s",
        "&:hover":
          isClickable && !isActive ? { borderBottom: "2px solid #90caf9" } : {},
      }}
    >
      <Typography
        fontSize="16px"
        fontWeight={isActive ? 600 : 400}
        color={isActive ? "#3F95EA" : isClickable ? "#6B7280" : "#9CA3AF"}
        noWrap
        sx={{
          transition: "color 0.15s",
          "&:hover": isClickable && !isActive ? { color: "#3F95EA" } : {},
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

const UserAdditon = ({
  open = true,
  onClose,
  onSuccess,
  disableNavigation = false,
  userId,
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openPreview, setOpenPreview] = useState(false);

  const tabs = ["Basic Info & Permissions", "Company & Branch"];

  const [formErrors, setFormErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [UpdateAssignedUserState, setUpdateAssignedUserState] = useState([]);
  const [role, setRole] = useState({});
  const [selectedAdmin, setSelectedAdmin] = useState({});
  const [assigneduserData, setassigneduserData] = useState([]);
  const [MenuPermissionerror, setMenuPermissionerror] = useState({
    roleError: false,
    adminError: false,
  });
  const [defaultUnderAssignedComp, setDefaultUnderAssignedComp] = useState({});
  const [selectedCompanyAdmin, setSelectedCompanyAdmin] = useState({});
  const tempSelectedCompanyAdmin = useRef(null);
  const [selectedAssignedAdmins, setSelectedAssignedAdmins] = useState({});
  const [assignedUserAuthorityLists, setassignedUserAuthorityLists] = useState(
    {},
  );
  const handlePreviewChange = () => setOpenPreview(false);
  const selectedUserId = useSelector((state) => state.user.user_id);
  const user_id = userId ?? selectedUserId;
  const [permissions, setPermissions] = useState({
    company: "addEdit",
    branch: "addEdit",
    job: "addEdit",
    candidate: "addEdit",
  });
  const [company, setCompany] = useState([]);
  const [companyRadioValue, setCompanyRadioValue] = useState("select");
  const [selectedCompanies, setSelectedCompanies] = useState([-100]);
  const [companySelectError, setCompanySelectError] = useState(false);
  const [branch, setBranch] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [branchRadioValue, setBranchRadioValue] = useState("");
  const [branchSelectError, setBranchSelectError] = useState(
    new Array(
      selectedBranches.filter((b) => b?.is_branch_managed === 1).length,
    ).fill(false),
  );
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [snackbarmessage, setSnackbarmessage] = useState("");
  const [showSnackbarmessage, setShowSnackbarmessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [branchMessage, setbranchMessage] = useState("");
  const [defaultSelectedBranches, setDefaultSelectedBranches] = useState([]);
  const [recruiterRadio, setRecruiterRadio] = useState(true);
  const defaultSelectedAdminRef = useRef(null);
  const currentRoleType = useRef(null);
  const roleType = useRef(null);
  const [selectedUserDetails, setSelectedUserDetails] = useState({});

  useEffect(() => {
    setDefaultUnderAssignedComp(
      Object.entries(selectedCompanyAdmin)
        .filter(([_, company]) => company.id === selectedUserDetails.user_id)
        .map(([id]) => ({ id: Number(id) })),
    );
  }, [selectedCompanyAdmin]);

  const [defaultSelectedCompanies, setDefaultSelectedCompanies] = useState([]);

  useEffect(() => {
    if (company.length > 0) {
      setDefaultSelectedCompanies(
        company.filter((comp) =>
          defaultUnderAssignedComp.some((s) => s.id === comp.id),
        ),
      );
      const defaultBranches = selectedBranches.filter((comp) =>
        defaultUnderAssignedComp.some((s) => s.id === comp.company_id),
      );
      setDefaultSelectedBranches(
        defaultBranches.length > 0 ? defaultBranches : selectedBranches,
      );
    } else {
      setDefaultSelectedCompanies([]);
    }
  }, [company, defaultUnderAssignedComp, selectedBranches]);

  const [userData, setUserData] = useState([]);

  const getCompanyLists = async () => {
    try {
      const response = await axios.post(
        "/list-of-companies",
        { under_assigned_user_id: selectedAdmin?.id },
        {
          headers: {
            Authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      );
      const companies = response.data.message.companyListResponse;
      setCompany(companies);
      if (
        (searchParams.get("edit") === null ||
          searchParams.get("edit") === "1") &&
        companyRadioValue === "all"
      ) {
        setSelectedBranches(
          companies.map((company) => {
            const branchIndex = selectedBranches.findIndex(
              (b) => b.company_id === company.id,
            );
            return branchIndex === -1
              ? {
                  company_id: company.id,
                  company_name: company.name,
                  branches: company.is_branch_managed === 1 ? [-100] : [],
                  is_branch_managed: company.is_branch_managed,
                }
              : selectedBranches[branchIndex];
          }),
        );
      }
      const hasBranch = userData.companiesBranchList.length === 0;
      const companyId = userData.companiesList[0]?.id;
      const company_ = companies.find((c) => c.id === companyId);
      const isBranchManaged = company_
        ? company_.is_branch_managed === 1
        : false;
      setbranchMessage(
        hasBranch && isBranchManaged
          ? "Selected assign user under does not have access to the branch in this company."
          : "",
      );
    } catch (error) {
      console.error("Error fetching company lists:", error);
    }
  };

  useEffect(() => {
    if (selectedAdmin && Object.keys(selectedAdmin).length > 0)
      getCompanyLists();
  }, [selectedAdmin]);

  const handleInputChane = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" });
  };
  const handleFocus = (e) =>
    setFormErrors({ ...formErrors, [e.target.name]: "" });

  const validate = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formValues.firstName) errors.firstName = "First Name is required";
    if (!formValues.email) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formValues.email)) {
      errors.email = "Email is invalid";
    }
    if (!user_id) {
      if (!formValues.password) {
        errors.password = "Password is required";
      } else if (formValues.password.length < 6) {
        errors.password = "Password must be at least 6 characters long";
      }
      if (!formValues.confirmPassword) {
        errors.confirmPassword = "Confirm Password is required";
      } else if (formValues.password !== formValues.confirmPassword) {
        errors.confirmPassword = "Passwords do not match";
      }
    }
    return errors;
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const accessType = {
    200: {
      add: permissions.company === "addEdit",
      edit: permissions.company === "addEdit",
      view: true,
    },
    500: {
      add: permissions.branch === "addEdit",
      edit: permissions.branch === "addEdit",
      view: true,
    },
    400: {
      add: permissions.job === "addEdit",
      edit: permissions.job === "addEdit",
      view: true,
    },
    100: {
      add: permissions.candidate === "addEdit",
      edit: permissions.candidate === "addEdit",
      view: true,
    },
  };

  const handleCompanyChange = (e) => {
    const { value } = e.target;
    const selectedids = selectedCompanies.map((c) => c.id);
    const newCompany = value.filter((c) => !selectedids.includes(c.id));
    setSelectedCompanies([...selectedCompanies, ...newCompany]);
    if (value.length > 0) {
      setCompanySelectError(false);
      if (companyRadioValue === "select") {
        setSelectedBranches(
          value.map((company) =>
            selectedBranches.findIndex((b) => b.company_id === company.id) ===
            -1
              ? {
                  company_id: company?.id,
                  company_name: company?.name,
                  branches: company.is_branch_managed === 1 ? [-100] : [],
                  is_branch_managed: company?.is_branch_managed,
                }
              : selectedBranches.find((b) => b.company_id === company.id),
          ),
        );
      }
    }
  };

  const handleCompanyRadioChange = (event) => {
    setCompanyRadioValue(event.target.value);
    if (event.target.value === "select") {
      setSelectedCompanies([]);
      setCompanySelectError(false);
      setSelectedBranches([]);
    }
    if (event.target.value === "all") {
      setSelectedCompanies([-100]);
      setSelectedBranches(
        company.map((c) => ({
          company_id: c.id,
          company_name: c.name,
          branches: c.is_branch_managed === 1 ? [-100] : [],
          is_branch_managed: c.is_branch_managed,
        })),
      );
    }
    if (companyRadioValue === "select") {
      setSelectedBranches(
        company.map((c) => ({
          company_id: c.id,
          company_name: c.name,
          branches: c.is_branch_managed === 1 ? [-100] : [],
          is_branch_managed: c.is_branch_managed,
        })),
      );
    }
  };

  const handleDeleteCompany = (companyToDelete) => {
    setSelectedCompanies(
      selectedCompanies.filter((c) => c.id !== companyToDelete.id),
    );
    setSelectedBranches(
      selectedBranches.filter((b) => b.company_id !== companyToDelete.id),
    );
  };

  const handleCompanySelectionError = () => {
    setCompanySelectError(
      companyRadioValue === "select" && selectedCompanies.length === 0,
    );
  };

  const handleBranchChange = (e, index) => {
    const { value } = e.target;
    const selectedBranchIds = selectedBranches[index].branches.map((b) =>
      Number(b.id),
    );
    const newBranches = value.filter(
      (b) => !selectedBranchIds.includes(Number(b.id)),
    );
    const updatedSelectedBranches = [...selectedBranches];
    updatedSelectedBranches[index].branches = [
      ...selectedBranches[index].branches,
      ...newBranches,
    ];
    setSelectedBranches(updatedSelectedBranches);
  };

  const handleBranchRadioChange = (event, index, bvalue) => {
    const updateSelectedBranches = [...selectedBranches];
    updateSelectedBranches[index] = {
      ...updateSelectedBranches[index],
      branches: bvalue.length > 0 && bvalue[0] === -100 ? [] : [-100],
    };
    setSelectedBranches(updateSelectedBranches);
  };

  const handleDeleteBranch = (index, idx) => {
    const newSelectedBranches = [...selectedBranches];
    newSelectedBranches[index].branches.splice(idx, 1);
    setSelectedBranches(newSelectedBranches);
  };

  function handleBranchSelectionError(index) {
    const errors = [...branchSelectError];
    errors[index] = selectedBranches[index].branches.includes(-100);
    setBranchSelectError(errors);
  }

  const modifiedSelectedBranchPayload =
    selectedBranches.length < 1
      ? []
      : defaultSelectedBranches.map((branch) => {
          const { company_name, is_branch_managed, ...rest } = branch;
          return {
            ...rest,
            branches:
              branch?.branches?.length === 0
                ? [-100]
                : !branch?.branches?.includes(-100)
                  ? branch?.branches?.map((bid) => bid.id)
                  : branch?.branches,
          };
        });

  const modifiedSelectedCompanyPayload = selectedCompanies.map((c) =>
    c.id ? c.id : -100,
  );

  const fetchUserdata = async () => {
    if (!user_id) return;
    try {
      const response = await axios.get(`/user-info/${user_id}`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      setUserData(response.data.message);
      setFormValues({ ...formValues, ...response.data.message.basic_info });
      const role_name = {
        id: response.data.message?.basic_info?.role_id,
        name: response.data.message?.basic_info?.role_name,
      };
      currentRoleType.current = role_name;
      setRole(role_name);
      const selectedAuthorizename = {
        id: response.data.message?.basic_info?.under_assigned_user_id,
        name: response.data.message?.basic_info?.under_assigned_user_name,
        username: response.data.message?.basic_info?.user_name,
        user_id: response.data.message?.basic_info?.user_id,
        hierarchy_id: response.data.message?.hierarchyId?.hierarchyId,
      };
      defaultSelectedAdminRef.current = selectedAuthorizename;
      setSelectedAdmin(selectedAuthorizename);
      setSelectedUserDetails(selectedAuthorizename);
      setCompanyRadioValue(
        response.data.message?.basic_info?.has_full_company_access === 1
          ? "all"
          : "select",
      );
      setSelectedCompanies(response.data.message.companiesList);
      setSelectedBranches(response.data.message.companiesBranchList);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAssignedUsers = async () => {
    if (!user_id) return;
    try {
      const response = await axios.get(`/assigned-user-info/${user_id}`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      setassigneduserData(response.data.message);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUserdata();
    fetchAssignedUsers();
  }, [user_id]);

  const payload = {
    firstName: formValues.firstName,
    lastName: formValues.lastName,
    email: formValues.email,
    password: formValues.password,
    user_role_id: role?.id,
    under_assigned_user_id: selectedAdmin?.id,
    companiesList: modifiedSelectedCompanyPayload,
    companiesBranchList: modifiedSelectedBranchPayload,
  };

  const UpdateUser = {
    firstName: formValues.firstName,
    lastName: formValues.lastName,
    email: formValues.email,
    original_date_modified: formValues.original_date_modified,
    user_role_id: role?.id,
    under_assigned_user_id: selectedAdmin?.id,
    companiesList: modifiedSelectedCompanyPayload,
    companiesBranchList: modifiedSelectedBranchPayload,
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSubmitted(false);
  };
  const handleCloseSnackbar = () => setShowSnackbar(false);

  const handleClose = () => {
    if (disableNavigation) {
      if (onClose) onClose();
      return;
    }
    if (user_id) navigate(`/UsersDetails/${user_id}?tab=b_info`);
    else navigate(`/Users?page=1`);
  };

  const updateTabSearchParams = (tab) => {
    if (disableNavigation) return;
    if (user_id) setSearchParams({ tab, user_id, edit: 1 });
    else setSearchParams({ tab });
  };

  const updateAssignedUser = async () => {
    try {
      await axios.post(`/edit-assignedUnder-user`, UpdateAssignedUserState, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      tempSelectedCompanyAdmin.current = null;
    } catch (error) {
      console.error(error);
    }
  };

  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleSnackbarClose}>
        UNDO
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackbarClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const createUser = async () => {
    try {
      setLoading(true);
      const response = await axios.post("/create-user", payload, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      if (response.data.status === 200) {
        setSnackbarmessage(response.data.message.msg);
        setSubmitted(true);
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          setLoading(false);
          if (disableNavigation) {
            if (onSuccess) onSuccess();
            if (onClose) onClose();
          } else {
            navigate("/Users?page=1");
          }
        }, 1500);
      } else if (response.data.status === 400) {
        setSnackbarmessage(response.data.message.msg);
        setSnackbarSeverity("error");
        setLoading(false);
      }
    } catch (error) {
      setSnackbarmessage(error.response.data.error);
      setSnackbarSeverity("error");
      setLoading(false);
      console.error(error);
    }
  };

  const updateUser = async () => {
    try {
      const my_user_id = localStorage.getItem("user_id");
      console.log("user iddddddddddd my ", my_user_id);

      setLoading(true);
      const response = await axios.post(
        `/edit-user/${user_id}`,
        { ...UpdateUser, my_user_id },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      );
      if (response.data.status === 200) {
        setSnackbarmessage(response.data.message);
        setSnackbarSeverity("success");
        setSubmitted(true);
        setOpenSnackbar(true);
        setTimeout(() => {
          setLoading(false);
          if (disableNavigation) {
            if (onSuccess) onSuccess();
            if (onClose) onClose();
          } else {
            navigate(`/UsersDetails/${user_id}?tab=b_info`);
          }
        }, 1500);
      }
    } catch (error) {
      setLoading(false);
      setSnackbarmessage(error.response.data.error);
      setSnackbarSeverity("error");
      setTimeout(() => {
        setOpenPreview(false);
        setSubmitted(false);
        setOpenSnackbar(false);
      }, 2500);
      console.error(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      setOpenPreview(false);
      setLoading(false);
      if (
        errors.firstName ||
        errors.email ||
        errors.password ||
        errors.confirmPassword
      ) {
        setValue(0);
        updateTabSearchParams("basicInfo");
        return;
      }
    }
    if (
      (Array.isArray(role) && role.length === 0) ||
      (typeof role === "object" && Object.keys(role).length === 0)
    ) {
      setOpenPreview(false);
      setLoading(false);
      setMenuPermissionerror({ ...MenuPermissionerror, roleError: true });
      setValue(0);
      updateTabSearchParams("basicInfo");
      return;
    }
    if (
      (Array.isArray(selectedAdmin) && selectedAdmin.length === 0) ||
      (typeof selectedAdmin === "object" &&
        Object.keys(selectedAdmin).length === 0) ||
      (selectedAdmin.id == "" && selectedAdmin.name == "")
    ) {
      setOpenPreview(false);
      setLoading(false);
      setMenuPermissionerror({ ...MenuPermissionerror, adminError: true });
      setValue(0);
      updateTabSearchParams("basicInfo");
      return;
    }
    if (companyRadioValue === "select" && selectedCompanies.length === 0) {
      setCompanySelectError(true);
      setValue(1);
      updateTabSearchParams("company");
      return;
    } else {
      setCompanySelectError(false);
    }

    let branchErrors = false;
    const branchSelectErrors = [...branchSelectError];
    selectedBranches.forEach((selectedbranch, index) => {
      if (
        selectedbranch.is_branch_managed === 1 &&
        selectedbranch.branches.length < 1
      ) {
        branchSelectErrors[index] = true;
        branchErrors = true;
      } else {
        branchSelectErrors[index] = false;
      }
    });
    setBranchSelectError(branchSelectErrors);
    if (branchErrors) {
      setValue(1);
      updateTabSearchParams("branch");
      return;
    }
    if (Object.keys(errors).length === 0) setOpenPreview(true);
    else {
      setOpenPreview(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab === "basicInfo" || tab === "role_permissions") setValue(0);
    else if (tab === "company" || tab === "branch") setValue(1);
  }, [searchParams, role, selectedAdmin, user_id]);

  const handleChange = (newValue) => {
    setValue(newValue);
    const newTab = newValue === 0 ? "basicInfo" : "company";
    updateTabSearchParams(newTab);
  };

  useEffect(() => {
    if (disableNavigation && user_id) roleType.current = true;
    if (
      !disableNavigation &&
      window.location.href.includes("basicInfo") &&
      window.location.href.includes("edit=1")
    )
      roleType.current = true;
    setValue(0);
    handleChange(0);
    setMenuPermissionerror({
      ...MenuPermissionerror,
      adminError: false,
      roleError: false,
    });
  }, []);

  const isTabClickable = (idx) => {
    if (idx === value) return false;
    if (
      idx === 1 &&
      (!formValues.firstName ||
        !formValues.email ||
        Object.keys(role).length === 0 ||
        Object.keys(selectedAdmin).length === 0)
    )
      return false;
    return true;
  };

  return (
    <Box>
      <Modal open={open}>
        <Box sx={modalLoadingContainerSx(loading, modalStyle)}>
          {/* ── Header — same as AddCompany ── */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: "20px",
              py: "8px",
              borderBottom: "1px solid #E5E7EB",
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{ fontSize: "18px", fontWeight: 600, color: "#111827" }}
            >
              {user_id ? "Edit User" : "Add User"}
            </Typography>
            <Button
              onClick={handleClose}
              sx={{ minWidth: 0, p: 0.5, color: "#6B7280" }}
            >
              <CloseIcon sx={{ fontSize: "18px" }} />
            </Button>
          </Box>

          {/* ── Tabs — same as AddCompany ── */}
          <Box
            sx={{
              borderBottom: "1px solid #E5E7EB",
              backgroundColor: "#F9FAFB",
              flexShrink: 0,
              px: "20px",
            }}
          >
            <Box display="flex" gap={3}>
              {tabs.map((label, idx) => (
                <StepTab
                  key={label}
                  label={label}
                  index={idx}
                  activeStep={value}
                  onTabClick={handleChange}
                  isClickable={isTabClickable(idx)}
                />
              ))}
            </Box>
          </Box>

          {/* ── Scrollable Body ── */}
          <Box sx={{ overflowY: "auto", flex: 1, px: 0, py: 0 }}>
            {/* Tab 0 — Basic Info + Role Permissions */}
            {value === 0 && (
              <Box display="flex" flexDirection="column" gap={1.5} p={2.5}>
                {sectionLabel("Basic Info")}
                <BasicInfo
                  formErrors={formErrors}
                  formValues={formValues}
                  handleInputChane={handleInputChane}
                  handleFocus={handleFocus}
                  handleClickShowConfirmPassword={
                    handleClickShowConfirmPassword
                  }
                  handleClickShowPassword={handleClickShowPassword}
                  showPassword={showPassword}
                  showConfirmPassword={showConfirmPassword}
                />

                <Divider sx={{ my: 0.5 }} />

                {sectionLabel("Role & Permissions")}
                <PermissionUI
                  role={role}
                  selectedAdmin={selectedAdmin}
                  setSelectedAdmin={setSelectedAdmin}
                  setRole={setRole}
                  MenuPermissionerror={MenuPermissionerror}
                  setMenuPermissionerror={setMenuPermissionerror}
                  assignedUserData={assigneduserData}
                  userCompanyList={userData.companiesList}
                  setSelectedCompanies={setSelectedCompanies}
                  setDefaultUnderAssignedComp={setDefaultUnderAssignedComp}
                  selectedCompanyAdmin={selectedCompanyAdmin}
                  setSelectedCompanyAdmin={setSelectedCompanyAdmin}
                  tempSelectedCompanyAdmin={tempSelectedCompanyAdmin}
                  defaultSelectedCompanies={defaultSelectedCompanies}
                  setUpdateAssignedUserState={setUpdateAssignedUserState}
                  defaultSelectedAdminRef={defaultSelectedAdminRef}
                  currentRoleType={currentRoleType}
                  recruiterRadio={recruiterRadio}
                  setRecruiterRadio={setRecruiterRadio}
                  setShowSnackbar={setShowSnackbar}
                  showSnackbarmessage={showSnackbarmessage}
                  setShowSnackbarmessage={setShowSnackbarmessage}
                  selectedAssignedAdmins={selectedAssignedAdmins}
                  setSelectedAssignedAdmins={setSelectedAssignedAdmins}
                  assignedUserAuthorityLists={assignedUserAuthorityLists}
                  setassignedUserAuthorityLists={setassignedUserAuthorityLists}
                  company={company}
                  roleType={roleType}
                />
              </Box>
            )}

            {/* Tab 1 — Company + Branch */}
            {value === 1 && (
              <Box display="flex" flexDirection="column" gap={1.5} p={2.5}>
                {/* {sectionLabel("Company")} */}
                <Companyselection
                  company={company}
                  selectedCompanies={selectedCompanies}
                  setSelectedCompanies={setSelectedCompanies}
                  handleCompanyChange={handleCompanyChange}
                  companyRadioValue={companyRadioValue}
                  setIsCompanyTab={() => {}}
                  handleCompanyRadioChange={handleCompanyRadioChange}
                  handleDeleteCompany={handleDeleteCompany}
                  handleCompanySelectionError={handleCompanySelectionError}
                  companySelectError={companySelectError}
                  defaultUnderAssignedComp={defaultUnderAssignedComp}
                />

                <Divider sx={{ my: 0.5 }} />

                {sectionLabel("Branch")}
                <BranchSelection
                  branch={branch}
                  branchMessage={branchMessage}
                  selectedAdmin={selectedAdmin?.id}
                  setBranch={setBranch}
                  selectedBranches={defaultSelectedBranches}
                  setSelectedBranches={setSelectedBranches}
                  handleBranchChange={handleBranchChange}
                  branchRadioValue={branchRadioValue}
                  setBranchRadioValue={setBranchRadioValue}
                  handleBranchRadioChange={handleBranchRadioChange}
                  handleDeleteBranch={handleDeleteBranch}
                  handleBranchSelectionError={handleBranchSelectionError}
                  branchSelectError={branchSelectError}
                />
              </Box>
            )}
          </Box>

          {/* ── Footer — same as AddCompany ── */}
          <Box sx={{ flexShrink: 0, borderTop: "1px solid rgba(0,0,0,0.12)" }}>
            <Box
              sx={{
                px: 3,
                py: 1.5,
                display: "flex",
                justifyContent: "flex-end",
                gap: 1.5,
              }}
            >
              <Button
                variant="contained"
                onClick={
                  value === 0
                    ? handleClose
                    : () => handleChange(value - 1)
                }
                sx={cancelBtnSx}
                disableElevation
              >
                {value === 0 ? "Cancel" : "Back"}
              </Button>

              {value < 1 ? (
                <Button
                  variant="contained"
                  onClick={() => handleChange(value + 1)}
                  sx={primaryBtnSx}
                  disableElevation
                >
                  Next
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  sx={primaryBtnSx}
                  disableElevation
                >
                  Preview
                </Button>
              )}
            </Box>
          </Box>
          <ModalLoadingOverlay open={loading} />
        </Box>
      </Modal>

      <Snackbar
        open={showSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} elevation={6} severity="warning">
          {showSnackbarmessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          elevation={6}
          severity={snackbarSeverity}
        >
          {snackbarmessage}
        </Alert>
      </Snackbar>

      {openPreview && (
        <UserDetailsPreview
          branchMessage={branchMessage}
          formValues={formValues}
          role={role?.name}
          selectedAdmin={selectedAdmin?.name}
          openPreview={openPreview}
          handlePreviewChange={handlePreviewChange}
          accessType={accessType}
          user_id={user_id}
          submitted={submitted}
          selectedCompanies={selectedCompanies}
          selectedBranches={defaultSelectedBranches}
          setSubmitted={setSubmitted}
          action={action}
          snackbarSeverity={snackbarSeverity}
          snackbarmessage={snackbarmessage}
          handleSnackbarClose={handleSnackbarClose}
          updateUser={updateUser}
          createUser={createUser}
          updateAssignedUser={updateAssignedUser}
          loading={loading}
        />
      )}
    </Box>
  );
};

export default UserAdditon;
